export default __webpack_public_path__ + "static/media/Poppins-Bold.dd24d10e.woff2";